import { z } from "zod";

export const AdminOrderEmailPreferencesSchema = z.object({
  admin_order_emails_enabled: z.boolean(),
  admin_order_email_recipients: z.array(z.string().email()),
});

export const AdminOrderEmailPreferencesUpdateSchema =
  AdminOrderEmailPreferencesSchema.extend({
    admin_order_email_recipients: z.array(z.string().email()).min(1),
  });

export type AdminOrderEmailPreferences = z.infer<
  typeof AdminOrderEmailPreferencesSchema
>;
export type AdminOrderEmailPreferencesUpdate = z.infer<
  typeof AdminOrderEmailPreferencesUpdateSchema
>;
